// extracted by mini-css-extract-plugin
export default {"input_block":"addKpiTask_input_block__qrIgo","input_block_title":"addKpiTask_input_block_title__yCSJR","error":"addKpiTask_error__QK+4y","buttons":"addKpiTask_buttons__5JLCI"};